import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-financial-welfare',
  templateUrl: './financial-welfare.component.html',
  styleUrls: ['./financial-welfare.component.scss']
})
export class FinancialWelfareComponent implements OnInit {

  welfareImages = [
    '/assets/img/quick-links/welfare/1 (1).jpg',
    '/assets/img/quick-links/welfare/1 (2).jpg',
    '/assets/img/quick-links/welfare/1 (3).jpg',
    '/assets/img/quick-links/welfare/1 (4).jpg',
    '/assets/img/quick-links/welfare/1 (5).jpg',
    '/assets/img/quick-links/welfare/1 (6).jpg',
    '/assets/img/quick-links/welfare/1 (7).jpg',
    '/assets/img/quick-links/welfare/1 (8).jpg',
    '/assets/img/quick-links/welfare/1 (9).jpg',
    '/assets/img/quick-links/welfare/1 (10).jpg',
    '/assets/img/quick-links/welfare/1 (11).jpg',
    '/assets/img/quick-links/welfare/1 (12).jpg',
    '/assets/img/quick-links/welfare/1 (13).jpg',
    '/assets/img/quick-links/welfare/1 (14).jpg',
    '/assets/img/quick-links/welfare/1 (15).jpg',
    '/assets/img/quick-links/welfare/1 (16).jpg',
    '/assets/img/quick-links/welfare/1 (17).jpg',
    '/assets/img/quick-links/welfare/1 (18).jpg',
    '/assets/img/quick-links/welfare/1 (19).jpg',
    '/assets/img/quick-links/welfare/1 (20).jpg',
    '/assets/img/quick-links/welfare/1 (21).jpg',
    '/assets/img/quick-links/welfare/1 (22).jpg',
    '/assets/img/quick-links/welfare/1 (23).jpg',
    '/assets/img/quick-links/welfare/1 (24).jpg',
    '/assets/img/quick-links/welfare/1 (25).jpg',
    '/assets/img/quick-links/welfare/1 (26).jpg',
    '/assets/img/quick-links/welfare/1 (27).jpg',
    '/assets/img/quick-links/welfare/1 (28).jpg',
    '/assets/img/quick-links/welfare/1 (29).jpg',
    '/assets/img/quick-links/welfare/1 (30).jpg',
    '/assets/img/quick-links/welfare/1 (31).jpg',
    '/assets/img/quick-links/welfare/1 (32).jpg',
    '/assets/img/quick-links/welfare/1 (33).jpg',
    '/assets/img/quick-links/welfare/1 (34).jpg',
    '/assets/img/quick-links/welfare/1 (35).jpg',
    '/assets/img/quick-links/welfare/1 (36).jpg',
    '/assets/img/quick-links/welfare/1 (37).jpg',
    '/assets/img/quick-links/welfare/1 (38).jpg',
    '/assets/img/quick-links/welfare/1 (39).jpg',
    '/assets/img/quick-links/welfare/1 (40).jpg',
    '/assets/img/quick-links/welfare/1 (41).jpg',
    '/assets/img/quick-links/welfare/1 (42).jpg',
    '/assets/img/quick-links/welfare/1 (43).jpg',
    '/assets/img/quick-links/welfare/1 (44).jpg',
    '/assets/img/quick-links/welfare/1 (45).jpg',
    '/assets/img/quick-links/welfare/1 (46).jpg',
    '/assets/img/quick-links/welfare/1 (47).jpg',
    '/assets/img/quick-links/welfare/1 (48).jpg',
    '/assets/img/quick-links/welfare/1 (49).jpg',
    '/assets/img/quick-links/welfare/1 (50).jpg',
    '/assets/img/quick-links/welfare/1 (51).jpg',
    '/assets/img/quick-links/welfare/1 (52).jpg',
    '/assets/img/quick-links/welfare/1 (53).jpg',
    '/assets/img/quick-links/welfare/1 (54).jpg',
    '/assets/img/quick-links/welfare/1 (55).jpg',
    '/assets/img/quick-links/welfare/1 (56).jpg',
    '/assets/img/quick-links/welfare/1 (57).jpg',
    '/assets/img/quick-links/welfare/1 (58).jpg',
    '/assets/img/quick-links/welfare/1 (59).jpg',
    '/assets/img/quick-links/welfare/1 (60).jpg',
    '/assets/img/quick-links/welfare/1 (61).jpg',
    '/assets/img/quick-links/welfare/1 (62).jpg',
    '/assets/img/quick-links/welfare/1 (63).jpg',
    '/assets/img/quick-links/welfare/1 (64).jpg',
    '/assets/img/quick-links/welfare/1 (65).jpg',
    '/assets/img/quick-links/welfare/1 (66).jpg',
    '/assets/img/quick-links/welfare/1 (67).jpg',
  ];

  constructor() { }

  ngOnInit(): void { }

}
